import {createStore, applyMiddleware, compose, Store as ReduxStore, AnyAction, Action} from 'redux';
import {types as globalTypes} from 'redux-act';
import thunk, {ThunkDispatch} from 'redux-thunk';
import {rootReducer} from './reducers';
import {ActionsDependencies} from './ActionsDependencies';

export type StoreState = ReturnType<typeof rootReducer>;
export type Store = ReduxStore<StoreState> & {dispatch: ThunkDispatch<any, any, AnyAction>};
export type StoreThunkDispatch = ThunkDispatch<StoreState, ActionsDependencies, Action>;

if (module.hot) {
	globalTypes.disableChecking();
}

const composeWithDevtool = typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__; // eslint-disable-lines no-underscore-dangle
const composeEnhancers = composeWithDevtool ? composeWithDevtool : compose; // TODO in future only with development mode

export function createConfiguredStore(dependencies: ActionsDependencies, predefinedState?: StoreState): Store {
	const thunkMw = thunk.withExtraArgument<ActionsDependencies>(dependencies);
	const mw = applyMiddleware(thunkMw);
	const store = createStore(rootReducer, predefinedState, composeEnhancers(mw));

	if (module.hot) {
		module.hot.accept('./reducers', () => {
			store.replaceReducer(rootReducer);
		});
	}

	return store;
}
